/**
 * API and URL Constants
 *
 * These constants hold environment variable values used throughout the application for:
 * - **baseUrl**: Base URL for the API.
 * - **baseApikey**: API key for making requests.
 * - **picBaseUrl**: Base URL for image resources.
 * - **Business_Portal_URL**: URL for the business portal.
 */

export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const baseApikey = process.env.REACT_APP_API_KEY;
export const picBaseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const Business_Portal_URL = process.env.REACT_APP_BUSINESS_PORTAL_URL;
